import { getState, setState, putBookmarks } from '../core';
import {
  setLocalBookmarks,
  isUserOnboarded,
  setUserAsOnboarded,
  getContentId,
} from '../helpers';
import * as actions from '../actions';

export const addBookmark = async () => {
  const contentId = getContentId(location.href);

  const { sessionLoggedIn } = getState();

  //eagerly set state before calling the endpoint
  setState({
    article: 'bookmarked',
    status: 'loading',
  });

  if (!contentId) {
    return actions.fail(false);
  }

  const newList = await putBookmarks(contentId, true);
  setLocalBookmarks(newList.bookmarkEvents);

  if (sessionLoggedIn) {
    const showOnboardingPopup = !isUserOnboarded();
    setUserAsOnboarded();

    setState({
      showOnboardingPopup,
      modalVisible: showOnboardingPopup,
      eventList: newList.bookmarkEvents,
      status: 'idle',
    });
  } else {
    setState({
      eventList: newList.bookmarkEvents,
      status: 'idle',
    });
  }
};
